import { useEffect, useState } from "react";
import dailyFilterDefault from '@/pages/dashboard/filterPageComponents/overview/dailyFilterDefault';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import { dailyRequest } from "../../pages/overview/_config/dailyRequest";

/**
 * 按照接口区分为不同model
 * hook名称规范：use+接口名称+Data
 * @param parentProps 父页面所有props
 * @param props: timeZone 时区信息，realtime特有
 * @param props: dispatch dva  dispatch方法
 * @returns
 * 获取数据的逻辑：dva中有数据则取dva中的数据，否则自己通过接口请求
 */

const useDailyRegionModel = (parentProps: any, formValue: any, dispatch: any, filterLoading: boolean, regionDataType: string,dailyReqType='normal') => {
  const { gameCode } = parentProps;
  const formVal = formValue || dailyFilterDefault;
  const [componentData, setComponentData] = useState({
    dau: {
      dau_date_list: [],
      dau_list: [],
    },
    revenue: {
      revenue_date_list: [],
      revenue_list: [],
    },
    new: {
      new_date_list: [],
      new_list: [],
    }
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // 进入页面，如果有dva数据则获取dva的数据，否则请求接口
  // useEffect(()=>{
  //     if(filterLoading) return;
  //     // const dvaData = serviceData?.[OVERVIEW_DAILY_REGION];
  //     // if (dvaData) {
  //     //     setComponentData(dvaData?.data)
  //     //     setLoading(false);
  //     // } else {
  //         // 当筛选器加载完成后再进行页面请求
  //         if (!filterLoading) {
  //             geRegionDataFunc()
  //         }
  //     // }
  // },[filterLoading])

  // 进入页面后，如果改变了筛选器，则重新请求接口
  useEffect(()=>{
    if(filterLoading || !formValue) return;
    geRegionDataFunc();
  },[formValue,regionDataType]);


  const geRegionDataFunc = (isRefresh?: boolean) => {
    const { filterValue } = formVal;
    const { rangeTime, ...filters } = filterValue;
    // 排行榜overview后端补齐
    const [start, end] = rangeTime;
    const params = {
      game_code: gameCode,
      filters: formatFilterValues(filters),
      start_time: start,
      end_time: end,
      by_type: regionDataType,
    };
    setLoading(!isRefresh);
    const requestFunc = dailyRequest?.getRegionCountriesZone?.[dailyReqType];
    requestFunc(params).then((result: any) => {
      setError('');
      setLoading(false);
      const data = {
        dau: {
          dau_date_list: result?.dau_date_list || [],
          dau_list: result?.dau_list || [],
        },
        revenue: {
          revenue_date_list: result?.revenue_date_list || [],
          revenue_list: result?.revenue_list || [],
        },
        new: {
          new_date_list: result?.new_date_list || [],
          new_list: result?.new_list || [],
        }
      };
      setComponentData(data);
      dispatch({
        type: "overview/getRegionDataFunc",
        payload: {
          data
        }
      });
    }).catch((err: any) => {
      setError(err);
      setLoading(false);
    });
  };
  return {
    // nodata 不在此封装，因为可能是接口的个别项目nodata
    componentData,
    loading,
    error,
  };
};

export default useDailyRegionModel;
